<template>
  <div style="font-size: 0.4rem; display: flex; align-items: center;flex-direction: column;margin-top: 0.6rem;">
    
    <van-uploader
            v-model="fileList"
            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            max-count="1"
            :after-read="afterRead"
            :before-delete="beforeDelete"
          >
          <template #default>
    <div class="excel-upload-btn">
      <span>+Excel</span>
    </div>
  </template>
   </van-uploader>
   <div style="display: flex;flex-direction: row; align-items: center;margin-top: 0.5rem;">
   <div> 替换已存在</div>
    <van-switch v-model="replace" />
   </div>


   

   <van-button
          type="primary"
          style="width:140px; height:40px; margin-top:0.5rem;"
          @click="saveExcelData"
        >上传</van-button>
    
   
        <div>{{ wrongMessage }}</div>
  </div>
</template>

<style scoped>
.excel-upload-btn {
  width: 240px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  transition: background 0.2s;
  border: 1px solid #1677ff;
  
  
}
.excel-upload-btn:hover {
  background: #409eff;
  border-color: #409eff;
}
</style>

<script setup>
import { ref, onMounted } from 'vue';
import { saveAudioLearnData } from '@/api/apiService';



onMounted(async () => {
  try {

console.log('AudioImport mounted');
    
  } catch (e) {
    console.error('Error in AudioImport mounted:', e);
  }
});

const fileList = ref([]);
const wrongMessage = ref('');
const replace = ref(false);


// 手动上传逻辑
const afterRead = async (file) => {

  console.log('file', file);
};


const saveExcelData = async () => {
  if(fileList.value.length == 0){
    alert('请先选择Excel文件');
    return;
  }

  const file = fileList.value[0];

  console.log('上传文件', file);

      const audioInfo = new FormData();

      audioInfo.append('file', file.file);
      audioInfo.append('replace', replace.value);

      

      try {
        const result = await saveAudioLearnData(audioInfo);
        if (result && result.code === 0) {
          fileList.value = [];
          wrongMessage.value = '上传成功';
        } else {
          wrongMessage.value = result.msg || '上传失败';
        }
        } catch (error) {
        wrongMessage.value = '上传异常，请稍后重试' + error.message;
        console.error('上传异常:', error);
  }

};

// 可选：删除前确认
const beforeDelete = (file, detail) => {
  console.log('delete file', file, detail);
  fileList.value = [];
  // return window.confirm('确定要删除这张图片吗？');
};


</script>

  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    
  }

 

    
    
  .submit_title{
    font-size: 0.5rem;
    
    margin-bottom: 0.6rem;
    color: #0a0eeb;
    text-align: left;
    
  }
  .submit_main_body{
    font-size: 0.4rem;
    color:#848488;
    width: 100%;
    align-items: flex-start;
    margin-left: 1rem;
    margin-bottom: 0.2rem;
    
    text-align: left;
  }


  .submit_first_class_tilte{
    font-size: 0.4rem;
    color:#0606e6;
    width: 100%;
    align-items: flex-start;
    margin-left: 1rem;
    margin-top: 0.2rem;
    
    text-align: left;
  }







  </style>